import { Navigate } from "react-router-dom";
import React from "react";

function CompanyDashboardPrivateRoutes({ children, redirectTo }) {
  const userData = localStorage.getItem("userVASData");
  const userObj = JSON.parse(userData);

  // Check if user data exists and extract role
  const isAuthenticated = {
    isLoggedIn: userObj ? userObj.isLoggedIn : false,
    // Get the first role in the array
    userRole: userObj?.responseDetails?.roles?.[0],
  };

  // If the user is not logged in or role is not 'Admin', redirect to the dashboard/company
  if (!isAuthenticated.isLoggedIn || isAuthenticated.userRole !== "CompanyUser") {
    return <Navigate to="/dashboard" />;
  }

  // If the user is logged in and is an Admin, render the protected content
  return children;
}

export default CompanyDashboardPrivateRoutes;
